import CircularProgress from "@material-ui/core/CircularProgress";
import Grid from "@material-ui/core/Grid";
import withStyles from "@material-ui/core/styles/withStyles";
import Typography from "@material-ui/core/Typography";
import PropTypes from "prop-types";
import React, { Component } from "react";
import { connect } from "react-redux";
import "react-step-progress-bar/styles.css";
import DayCard from "../components/DayCard";
import { getClass } from "../redux/actions/dataActions";


const styles = {
  root: {
    minWidth: "275px",
  },
  center: {
    margin: "auto 1em auto 1em",
    minWidth: "275px",
  },
  containerCentral: {
    justifyContent: "center",
  },
  lightText: {
    fontWeight: "100",
  },
};

class syllabus extends Component {
  componentDidMount() {
    const programId = this.props.match.params.programId;
    this.props.getClass(programId);
  }

  render() {
    const { classes } = this.props;

    const { syllabus, loading } = this.props.data;
    let dayCards =
      !loading && syllabus.length > 0 ? (
        syllabus.map((dayCard, i) => (
          <DayCard key={i} dayCard={dayCard} day={i} />
        ))
      ) : (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <CircularProgress />
        </div>
      );
    return (
      <Grid container className={classes.containerCentral}>
        <Grid item sm />
        <Grid item sm className={classes.center}>
          <Typography variant="h3">Exploration Sprint</Typography>
          {dayCards}
        </Grid>
        <Grid item sm />
      </Grid>
    );
  }
}

syllabus.propTypes = {
  data: PropTypes.object.isRequired,
  getClass: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  data: state.data,
});

export default connect(mapStateToProps, { getClass })(
  withStyles(styles)(syllabus)
);
